import { isNumeric } from 'shared/lib/isNumeric'

export const removeSpacesFromNumericString = (value: string) => {
  return isNumeric(value.split(' ').join('')) ? value.split(' ').join('') : value
}
